import {AfterViewChecked, ChangeDetectorRef, Component, Input, OnInit, ViewChildren} from '@angular/core';
import {UserService} from '../../../../core/services/user.service';
import {UserSelectionComponent} from '../../../../shared/components/dialog/user-selection/user-selection.component';
import {MatDialog} from '@angular/material/dialog';
import {FormBuilder} from '@angular/forms';
import {HttpService} from '../../../../core';
import {ToastrService} from 'ngx-toastr';
import {StatusDialogComponent} from './status-dialog/status-dialog.component';
import {environment} from '../../../../../environments/environment';
import {ActivatedRoute} from '@angular/router';


@Component({
  selector: 'app-permission',
  templateUrl: './permission.component.html',
  styleUrls: ['./permission.component.scss']
})

export class PermissionComponent implements OnInit, AfterViewChecked {

  @Input() project;
  highestRole: any;
  selectedUsers = [];
  selectedUserIds = [];
  statusForm: any;
  allSalesArray = [];
  selectedSaleIdArray = [];
  tabIndex = 1;
  agentSelected = 0;
  projectId: string;
  SERVER_URL = environment.SERVER_URL;
  searchInput = '';
  @ViewChildren('matCheckbox') matCheckbox: any;
  displayType: number;
  projectDetail: any;
  pageIndex: number;
  pageSize: number;
  length: number;
  totalElements: number;
  pageSizeOptions: number[] = [10, 25, 50, 100];
  selectedSales = [];
  savedType: number;
  customerChecked: boolean;
  isMore: boolean;
  userList = [];

  statuses = [
    // {
    //   id: -2,
    //   name: 'Invisible'
    // },
    {
      id: -1,
      name: 'Under Approval'
    },
    {
      id: 0,
      name: 'Disabled'
    },
    {
      id: 1,
      name: 'Live'
    }
  ];

  constructor(private userService: UserService, private cdr: ChangeDetectorRef, private dialog: MatDialog,
              private fb: FormBuilder, private httpService: HttpService, private toastrService: ToastrService, private route: ActivatedRoute, private cdRef: ChangeDetectorRef) {
    this.projectId = this.route.snapshot.paramMap.get('id');
    this.userService.currentUser.subscribe((user: any) => {
      this.highestRole = user.roles[0];
      this.statusForm = this.fb.group({
        status: [{value: '', disabled: this.highestRole.weight < 1000}]
      });
    });

  }

  ngOnInit(): void {
    this.httpService.getProjectDetailByProjectId(this.projectId).toPromise().then((projectDetail: any) => {
      console.log(projectDetail, 'getProjectDetailByProjectId');
      this.projectDetail = projectDetail.data;
      this.displayType = projectDetail.data.displayType;
      this.savedType = projectDetail.data.displayType;
      if (this.displayType === 4 || this.displayType === 12) {
        this.customerChecked = true;
      }
      if (projectDetail.data.displayType === 4 || projectDetail.data.displayType === 8 || projectDetail.data.displayType === 12) {
        this.tabIndex = 0;
      } else {
        this.tabIndex = 1;
      }
      this.httpService.getAgentCompanyList(0, 100, '').toPromise().then((salesList: any) => {
        this.allSalesArray = salesList.data.content;
        this.length = salesList.data.totalElements;
        this.pageIndex = salesList.data.number;
        this.pageSize = salesList.data.size;
        this.totalElements = salesList.data.totalElements;
        if (projectDetail.data.agencyCompanies && Object.keys(projectDetail.data.agencyCompanies).length > 0) {
          for (const eachAgency of projectDetail.data.agencyCompanies) {
            this.selectedSaleIdArray.push(eachAgency.id);
            this.selectedSales.push(eachAgency);
            this.agentSelected++;
          }
        }
      });
    });

    this.statusForm.patchValue({
      status: this.project.status
    });
    if (this.project && this.project.users && this.project.users.length) {
      if (this.project.users.length > 5) {
        this.isMore = true
        for (let index = 0; index < 5; index++) {
          this.userList.push(this.project.users[index])
        }
        this.isMore = true
      } else {
        this.userList = this.project.users
        this.isMore = false
      }
    }

  }

  viewMore() {
    this.userList = this.project.users
    this.isMore = false
  }

  viewLess() {
    this.isMore = true
    this.userList = []
    for (let index = 0; index < 5; index++) {
      this.userList.push(this.project.users[index])
    }
  }

  getSalesByPage(pageSize, e) {
    this.httpService.getAgentCompanyList(e ? e.pageIndex : 0, e ? e.pageSize : pageSize, this.searchInput).toPromise().then((salesList: any) => {
      console.log(salesList.data);
      this.allSalesArray = salesList.data.content;
      this.length = salesList.data.totalElements;
      this.pageIndex = salesList.data.number;
      this.pageSize = salesList.data.size;
      this.totalElements = salesList.data.totalElements;
    });

  }

  ngAfterViewChecked() {
    this.cdRef.detectChanges();
  }

  handleTabIndexChange(event) {
    if (this.tabIndex === 0) {
      this.tabIndex = 1;
    } else if (this.tabIndex === 1) {
      this.tabIndex = 0;
    }
  }

  handleChecked(event, eachAgency) {
    if (event.checked) {
      this.agentSelected++;
      this.selectedSaleIdArray.push(eachAgency.id);
      this.selectedSales.push(eachAgency);
    }
    if (!event.checked) {
      this.agentSelected--;
      const index = this.selectedSaleIdArray.indexOf(eachAgency.id);
      this.selectedSaleIdArray.splice(index, 1);
      this.selectedSales.splice(this.selectedSales.indexOf(eachAgency), 1);
    }
  }

  handleCheckAll(event) {
    if (event.checked) {
      for (const eachAgency of this.allSalesArray) {
        if (!this.selectedSaleIdArray.includes(eachAgency.id)) {
          this.selectedSaleIdArray.push(eachAgency.id);
          this.selectedSales.push(eachAgency);
          this.agentSelected++;
        }
      }
      for (const eachCheckbox of this.matCheckbox) {
        eachCheckbox.checked = true;
      }
    }
    if (!event.checked) {
      for (const eachAgency of this.allSalesArray) {
        if (this.selectedSaleIdArray.includes(eachAgency.id)) {
          console.log(eachAgency.id);
          console.log(this.selectedSaleIdArray);
          const index = this.selectedSaleIdArray.indexOf(eachAgency.id);
          console.log(index);
          this.selectedSaleIdArray.splice(index, 1);
          this.selectedSales.splice(this.selectedSales.indexOf(eachAgency), 1);
          this.agentSelected--;
        }
      }
      for (const eachCheckbox of this.matCheckbox) {
        eachCheckbox.checked = false;
      }
    }
  }

  isCheckboxChecked(eachAgency) {
    return this.selectedSaleIdArray.includes(eachAgency.id);
  }

  handleSubmit(event) {
    this.httpService.getAgentCompanyList(0, 10, this.searchInput).toPromise().then((salesList: any) => {
      this.allSalesArray = salesList.data.content;
      this.length = salesList.data.totalElements;
      this.pageIndex = salesList.data.number;
      this.pageSize = salesList.data.size;
      this.totalElements = salesList.data.totalElements;
    });
  }

  handleCustomerCheck(event) {
    if (event.checked) {
      this.customerChecked = true;
    }
    if (!event.checked) {
      this.customerChecked = false;
    }
  }

  handleUpdate() {
    const fd = new FormData();
    if (this.selectedSaleIdArray.length !== 0) {
      for (const id of this.selectedSaleIdArray) {
        fd.append('agencyCompanyIds', id);
      }
    } else {
      fd.append('agencyCompanyIds', '');
    }
    fd.append('displayType', '8');
    this.httpService.updateSalesOfProjectById(this.projectId, fd).toPromise().then((result: any) => {
      console.log(result, 'updateSalesOfProjectById');
      this.savedType = result.data?.displayType;
      this.project.displayType = result.data?.displayType;
      this.toastrService.success('Update Successfully');
    });
  }

  handleSave(val) {
    const fd = new FormData();
    if (this.tabIndex === 0) {
      if (this.customerChecked === true) {
        this.displayType = 4;
        if (this.selectedSaleIdArray.length !== 0) {
          this.displayType = 12;
        }
      } else {
        this.displayType = 8;
      }
    }
    if (this.displayType === 8 || this.displayType === 12) {

      if (this.selectedSaleIdArray.length !== 0) {
        for (const id of this.selectedSaleIdArray) {
          fd.append('agencyCompanyIds', id);
        }
      } else {
        fd.append('agencyCompanyIds', '');
      }
    }
    fd.append('displayType', val);//this.displayType.toString()
    this.httpService.updateSalesOfProjectById(this.projectId, fd).toPromise().then((result: any) => {
      console.log(result);
      this.project.displayType = val
      this.savedType = result.data?.displayType;
      this.toastrService.success('Update Successfully');
    });
  }

  openUserSelectionDialog(e) {
    e.preventDefault();
    const dialogRef = this.dialog.open(UserSelectionComponent, {
      width: '80%',
      height: '80%',
      disableClose: true,
      data: {selectedUsers: this.project.users, projectId: this.project.id}
    });

    dialogRef.afterClosed().subscribe((result: any) => {
      console.log('afterClosed', result);
      if (!result) {
        return;
      }

      if (result.code === 1) {
        this.userList = []
        this.toastrService.success('Project has been reassigned.');
        // this.ngOnInit()
        this.project.users = result.users;
        this.project.users.forEach((item: any) => {
          item.email = this.userService.getEmailFromContacts(item.contacts);
        });

        if (this.project.users.length > 5) {
          this.isMore = true
          for (let index = 0; index < 5; index++) {
            this.userList.push(this.project.users[index])
          }
          this.isMore = true
        } else {
          this.userList = this.project.users
          this.isMore = false
        }
      } else if (result.code === 0) {
        this.toastrService.error('Because the project is ' + (this.project.status === 0 ? 'deactivated' : 'being verified'), 'Failed to reassigned this project.');
      }
    });
  }

  changeStatus(val) {
    console.log(val, 'value')
    if (this.project.status !== val) {

      const dialogRef = this.dialog.open(StatusDialogComponent, {
        data: {
          project: this.project,
          targetStatus: val
        }
      });

      dialogRef.afterClosed().subscribe((result: any) => {
        if (result.result.code === 0) {
          this.statusForm.patchValue({
            status: this.project.status
          });
        } else {
          this.project.status = val
        }
      });
    } else {
      this.toastrService.warning('Please select a new status to update');
    }
  }

  getName(user) {
    if (user.contacts && user.contacts.length && user.contacts.filter(item => item.contactItem.id == 1).length) {
      return user.contacts.filter(item => item.contactItem.id == 1)[0].content;
    }
    return '';
  }

  getUserName(user) {
    if (user.firstName && user.lastName) {
      return user.lastName + ' ' + user.firstName;
    }
    return '';
  }
}
